import { createSelector } from 'reselect';
import { AppState } from '../store/types/Store';
import { PlantingLocaleGroup, PlantingEvent } from '../types';
import { getCurrentSeason } from './seasonSelectors';

export const getPlanting = (state: AppState) => state.planting;

export const getCurrentPlantingData = createSelector([getPlanting, getCurrentSeason], (planting, currentSeason) =>
  // TODO: Remove assertion after LI-889
  planting[currentSeason] as PlantingEvent | undefined
);

export const getPopulationFromPlantingData = createSelector(
  [getCurrentPlantingData],
  (plantingData) => plantingData && plantingData.population
);

export const isAirSeederPopulation = createSelector(
  [getPopulationFromPlantingData],
  (plantingPopulation) =>
    plantingPopulation?.localeGroup === PlantingLocaleGroup.POPULATION_WEIGHT
);
